import { render, staticRenderFns } from "./MyAgenda.vue?vue&type=template&id=6718ccf5&scoped=true&"
import script from "./MyAgenda.vue?vue&type=script&lang=js&"
export * from "./MyAgenda.vue?vue&type=script&lang=js&"
import style0 from "./MyAgenda.vue?vue&type=style&index=0&id=6718ccf5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6718ccf5",
  null
  
)

export default component.exports